import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["aria-expanded", "aria-label"]
const _hoisted_2 = { class: "nge-streak-chip-fire" }
const _hoisted_3 = {
  ref: "flameEl",
  class: "nge-streak-chip-flame"
}
const _hoisted_4 = {
  ref: "fireCv",
  class: "nge-streak-chip-canvas",
  "aria-hidden": "true"
}
const _hoisted_5 = { class: "nge-streak-chip-count" }
const _hoisted_6 = {
  key: 0,
  class: "nge-streak-tip",
  role: "tooltip"
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<span class=\"nge-streak-tip-beam\" aria-hidden=\"true\"></span><span class=\"nge-streak-tip-scan\" aria-hidden=\"true\"></span><i class=\"nge-streak-tip-brk tl\" aria-hidden=\"true\"></i><i class=\"nge-streak-tip-brk tr\" aria-hidden=\"true\"></i><i class=\"nge-streak-tip-brk bl\" aria-hidden=\"true\"></i><i class=\"nge-streak-tip-brk br\" aria-hidden=\"true\"></i>", 6)
const _hoisted_13 = {
  class: "nge-streak-tip-title nge-streak-tip-row",
  style: {"--i":"0"}
}
const _hoisted_14 = { class: "nge-streak-tip-num" }
const _hoisted_15 = ["title"]
const _hoisted_16 = ["title"]
const _hoisted_17 = {
  class: "nge-streak-tip-body nge-streak-tip-row",
  style: {"--i":"2"}
}
const _hoisted_18 = {
  key: 2,
  class: "nge-streak-tip-best nge-streak-tip-row",
  style: {"--i":"3"}
}
const _hoisted_19 = {
  key: 3,
  class: "nge-streak-tip-best nge-streak-tip-row",
  style: {"--i":"3"}
}
const _hoisted_20 = {
  key: 4,
  class: "nge-streak-tip-best nge-streak-tip-row",
  style: {"--i":"3"}
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "chipEl",
    class: _normalizeClass(["nge-streak-chip", { 'nge-streak-chip--open': $setup.open, 'holo-on': $setup.pinned }]),
    tabindex: "0",
    role: "button",
    "aria-expanded": $setup.open,
    "aria-label": `Editing streak: ${$props.current} days`,
    onPointerenter: $setup.onEnter,
    onPointerleave: $setup.onLeave,
    onFocus: $setup.onEnter,
    onBlur: $setup.onLeave,
    onClick: $setup.stoke,
    onKeydown: $setup.onKey
  }, [
    _createElementVNode("span", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, "🔥", 512 /* NEED_PATCH */),
      _createElementVNode("canvas", _hoisted_4, null, 512 /* NEED_PATCH */)
    ]),
    _createTextVNode(" "),
    _createElementVNode("span", _hoisted_5, _toDisplayString($props.current), 1 /* TEXT */),
    _createCommentVNode(" The card. v-if, so every opening is an arrival and runs its entrance once. "),
    ($setup.open)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_13, [
            _createTextVNode("🔥 "),
            _createElementVNode("span", _hoisted_14, _toDisplayString($setup.shownCount), 1 /* TEXT */),
            _createTextVNode("-day streak")
          ]),
          ($setup.usePips)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "nge-streak-tip-pips nge-streak-tip-row",
                style: {"--i":"1"},
                title: $setup.isBest ? 'Your best streak yet' : `${$props.current} of your best ${$props.best} days`
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pipTotal, (n) => {
                  return (_openBlock(), _createElementBlock("i", {
                    key: n,
                    class: _normalizeClass(["nge-streak-tip-pip", { 'is-lit': n <= $props.current, 'is-head': n === $props.current }]),
                    style: _normalizeStyle({ '--n': n })
                  }, null, 6 /* CLASS, STYLE */))
                }), 128 /* KEYED_FRAGMENT */))
              ], 8 /* PROPS */, _hoisted_15))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "nge-streak-tip-bar nge-streak-tip-row",
                style: {"--i":"1"},
                title: `${$props.current} of your best ${Math.max($props.current, $props.best)} days`
              }, [
                _createElementVNode("i", {
                  style: _normalizeStyle({ '--fill': Math.round($props.current / $setup.pipTotal * 100) + '%' })
                }, null, 4 /* STYLE */)
              ], 8 /* PROPS */, _hoisted_16)),
          _createElementVNode("div", _hoisted_17, _toDisplayString($setup.cheer), 1 /* TEXT */),
          ($props.best > $props.current)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Your best: " + _toDisplayString($props.best) + " days", 1 /* TEXT */))
            : ($props.current > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, "🏆 Your best streak yet!"))
              : ($props.current > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, "This is your best streak yet! 🏆"))
                : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_1))
}